import { useContext } from 'react';

export const useExpectedContext = <T>(
  context: React.Context<T>,
  undefined_message?: string
) => {
  const result = useContext(context);

  if (!result) {
    throw Error(undefined_message || 'Context did not have expected provider');
  }

  return result;
};
